export function formatPrice(amount: number, language: string): string {
  const locale = language === 'de' ? 'de-DE' : 'en-IE';
  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(amount);
}
